// extracted by mini-css-extract-plugin
export default {"body":"Question3_body__+NVCa","display":"Question3_display__uaC85","box":"Question3_box__69B2A","text":"Question3_text__+ZxrV","nav":"Question3_nav__720mD"};